// This file is designed to add extra functionalities to Plugin class

var PluginInfinityGettersMixin = {
  getSessionId: function () {
    return this.infinity.getLocal('session')
  },

  getContext: function () {
    return this.infinity.getSession('context')
  },

  getPageName: function () {
    if (document && document.title) {
      return document.title
    }
  },

  getIsSessionExpired: function () {
    var time = this.infinity.getSession('lastactive')
    var now = new Date().getTime()
    return !(this.getSessionId() && (time + this.options['session.expire'] > now))
  }
}

module.exports = PluginInfinityGettersMixin



//////////////////
// WEBPACK FOOTER
// ./src/plugin/plugin+infinity+getters.js
// module id = 41
// module chunks = 0